import { useContext, useState } from "react";
import { AppContext } from "../App";
import PopUp from "./PopUp";
import PlusMinusLarge from "./ui/PlusMinusLarge";
import functions from "../functions/functions";

export default function OpenTablePopup() {
	const {
		apiSettings,
		setOpenTablePopupVisible,
		table,
		user,
		lists,
		setTablesListVisible,
		init_cart,
		setTablePopup,
		menu,
		editTable,
		shop,
		setConfirm,
		setActiveFlow,
	} = useContext(AppContext);
	const [covers, setCovers] = useState(0);
	const [list, setList] = useState({ id: table.list_id });
	const [splittedCovers, setSplittedCovers] = useState([]);
	const [singleOrderMode, setSingleOrderMode] = useState(table.single_order_mode);

	const openTable = async () => {
		if (list && list.allyoucaneat == 1 && splittedCovers.length == 0) {
			setConfirm({
				title: "Errore",
				message: "Nessun menù selezionato",
			});
			return;
		}

		const openTablerequest = {
			status: 1,
			user_id: user.id,
			covers: covers,
			list_id: list ? list.id : null,
			single_order_mode: singleOrderMode,
		};
		if (list && list.allyoucaneat == 1) openTablerequest.splitted_covers = splittedCovers;
		const res = await editTable(table.id, openTablerequest);
		const cart_id = res.cart_id;

		const products = [];
		if (singleOrderMode == 1 || apiSettings.orders.generate_covers_order == 0) {
			if (!list || lists.allyoucaneat != 1) {
				if (covers > 0) {
					const coverProduct = findProduct("is_cover", 1);
					console.log(coverProduct);
					if (coverProduct) products.push({ ...coverProduct, qty: covers, flow: 1 });
				}
				const serviceProduct = findProduct("is_service", 1);
				console.log(serviceProduct);
				if (serviceProduct) products.push({ ...serviceProduct, qty: 1, flow: 1 });
			}
		}

		init_cart({
			covers: covers,
			list_id: list ? list.id : null,
			table: { ...table, cart_id: cart_id },
			room_id: table.room_id,
			delivery_type: {
				id: "shop",
				name: "Sala",
			},
			delivery_date: null,
			address: false,
			delivery_time_range: null,
			self_cart_id: cart_id,
			products: products,
		});
		setTablesListVisible(false);
		setOpenTablePopupVisible(false);
		setTablePopup(false);
		setActiveFlow(parseInt(table.flow) + 1);
	};

	const incrementSplittedCovers = (id) => {
		const index = splittedCovers.findIndex((el) => el.id == id);
		if (index > -1) {
			const newData = [...splittedCovers];
			newData[index].qty++;
			setSplittedCovers(newData);
		} else {
			setSplittedCovers([...splittedCovers, { id: id, qty: 1 }]);
		}
	};

	const decrementSplittedCovers = (id) => {
		const index = splittedCovers.findIndex((el) => el.id == id);
		if (index > -1) {
			if (splittedCovers[index].qty == 0) return;
			const newData = [...splittedCovers];
			newData[index].qty--;
			setSplittedCovers(newData);
		} else {
			setSplittedCovers([...splittedCovers, { id: id, qty: 1 }]);
		}
	};

	const getSplittedCovers = (id) => {
		const el = splittedCovers.find((el) => el.id == id);
		if (el) return el.qty;
		else return 0;
	};

	const getFilteredProducts = (filter) => {
		const res = [];
		for (const course of menu) {
			for (const category of course.categories) {
				for (const product of category.products) {
					if (product[filter] == 1) {
						if (list) {
							const priceList = product.prices.find(
								(p) => p.list_id == list.id && p.price
							);
							const assortment = product.assortment.find(
								(el) =>
									el.shop_id == shop.id && el.list_id == list.id && el.active == 1
							);
							console.log("priceList", priceList);
							if (priceList && assortment)
								res.push({ ...product, price: priceList.price });
						} else res.push(product);
					}
				}
			}
		}
		console.log("getFilteredProducts", filter, res);
		return res;
	};

	const findProduct = (field, value) => {
		for (const course of menu) {
			for (const category of course.categories) {
				for (const product of category.products) {
					//console.log("product", product.name, product[field]);
					if (product[field] == value) {
						if (list) {
							const priceList = product.prices.find(
								(p) => p.list_id == list.id && p.price
							);
							if (priceList) return { ...product, price: priceList.price };
						} else return product;
					}
				}
			}
		}
	};

	return (
		<PopUp
			size="sm"
			customClass="open-table-popup"
			options={{
				onClose: setOpenTablePopupVisible,
				title: "Apertura",
				subtitle: (
					<>
						<strong>{table.name}</strong>
						{table.room?.name ? " " + table.room.name : ""}
					</>
				),
				content: (
					<div className="open-table-popup-body">
						<div className="open-table-card">
							<div className="open-table-section-title">Listino</div>
							<div className="open-table-section-subtitle">
								Scegli quello da applicare al tavolo
							</div>
						<div className="lists-selector">
							{apiSettings.pos.hide_base_list != 1 && (
								<button
									className={"button" + (!list ? " button-1" : " button-3")}
									onClick={() => setList(false)}
								>
									Base
								</button>
							)}
							{lists.map((l, i) => (
								<button
									key={i}
									className={
										"button" +
										(list && l.id == list.id ? " button-1" : " button-3")
									}
									onClick={() => setList(l)}
								>
									{l.name}
								</button>
							))}
						</div>
						</div>
						{(!list || list.allyoucaneat != 1) && (
							<>
								<div className="open-table-card open-table-card-inline">
									<div className="open-table-inline-title">Ordine singolo</div>
									<button
										type="button"
										className={
											"open-table-switch" +
											(Number(singleOrderMode) === 1 ? " is-yes" : " is-no")
										}
										onClick={() =>
											setSingleOrderMode(Number(singleOrderMode) === 1 ? 0 : 1)
										}
										aria-pressed={Number(singleOrderMode) === 1}
									>
										<div className="open-table-switch-track">
											<span className="open-table-switch-label yes">SI</span>
											<span className="open-table-switch-label no">NO</span>
											<span className="open-table-switch-knob"></span>
										</div>
									</button>
								</div>
								<div className="open-table-card open-table-covers-card">
									<div>
										<div className="open-table-section-title">Coperti</div>
										<div className="open-table-section-subtitle">
											Scegli il numero di coperti
										</div>
									</div>
								<PlusMinusLarge value={covers} onChange={setCovers} />
								</div>
							</>
						)}
						{list && list.allyoucaneat == 1 && (
							<div className="open-table-card">
								<div className="open-table-section-title">Scegli i menu</div>
								<div className="menu-selector">
									{getFilteredProducts("is_selfordering_menu").map(
										(product, i) => (
											<div key={i}>
												<div>{product.name}</div>
												<div>
													{functions.formatter.format(product.price)}
													<button
														className="button button-1 square"
														onClick={() =>
															decrementSplittedCovers(product.id)
														}
													>
														-
													</button>
													<div>{getSplittedCovers(product.id)}</div>
													<button
														className="button button-1 square"
														onClick={() =>
															incrementSplittedCovers(product.id)
														}
													>
														+
													</button>
												</div>
											</div>
										)
									)}
								</div>
							</div>
						)}
						<button className="button button-2 open-table-submit" onClick={openTable}>
							Apri tavolo
						</button>
					</div>
				),
			}}
		/>
	);
}
